import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-option-form',
  templateUrl: './option-form.component.html',
  styleUrls: ['./option-form.component.css']
})
export class OptionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
